<template>
  <fo-layout>
    <div class="contact-news">
      <!-- 输入框 -->
      <div class="filter-input">
        <!-- <a-select class="item-input card-shadow" placeholder="Filter by industries" allowClear>
          <a-select-option value="jack"> Jack </a-select-option>
        </a-select> -->
        <a-input-search class="item-input card-shadow" placeholder="输入关键词搜索"
          allowClear
          @search="onSearch" />
      </div>
      <a-spin :spinning="loading">
        <fo-nodata v-if="!newsData.length"></fo-nodata>
        <a-row v-else :gutter="60">
          <a-col :sm="12" v-for="(item, index) in newsData" :key="index">
            <div class="pb-40">
              <!-- 日期 -->
              <div class="card-date">
                <i class="iconfont warning fs-24 mr-6">&#xe61d;</i>
                <span class="warning fs-20" v-if="item.news_atime">{{item.news_atime.split(' ')[0]}}</span>
              </div>
              <!-- 内容 -->
              <div class="card-item">
                <h1 class="card-title to-2"
                  @click="$router.push('./news/' + item.code + '?total=' + newsTotal)">{{item.news_title}}</h1>
                <p class="card-content to-4 silver" v-html="item.news_content.replace(/<p>/g, '')"></p>
                <!-- 跳转 -->
                <div class="card-btn">
                  <span class="primary"
                    @click="$router.push('./news/' + item.code + '?total=' + newsTotal)">查看详情 <a-icon type="right" /></span>
                </div>
                <div class="title-border"><!-- 底边线 --></div>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-spin>
      <!-- 页码 -->
      <div class="pagination-style">
        <a-pagination
          :default-current="1"
          :total="newsTotal"
          @change='onCurrentPageChange'
          @showSizeChange="onPageSizeChange"/>
      </div>
    </div>
  </fo-layout>
</template>
<script>
export default {
  data () {
    return {
      // 加载状态
      loading: false,
      // 客户总数
      newsTotal: 0,
      // 保存客户数据
      newsData: [],
      // 客户查询条件
      newsCond: {
        // 第几页
        page_num: 1,
        // 每页多少条
        page_size: 4,
        // 关键词搜索
        keyword: '',
        // 按年搜索
        news_year: ''
      },
      // 选中的页码数据
      current: 2,
      // 下拉框数据
      options: [
        {
          value: 'zhejiang',
          label: 'Zhejiang'
        }
      ]
    }
  },
  watch: {
    '$route' (obj) {
      if (obj.params.param) {
        window.scroll(0, 0)
      }
    }
  },
  mounted () {
    this.readItems()
  },
  methods: {
    /*
    * 搜索事件
    */
    onSearch (value) {
      this.newsCond.page_num = 1
      this.newsCond.keyword = value
      this.readItems()
    },
    /*
    * 换页事件
    */
    onCurrentPageChange (e) {
      if (e !== this.newsCond.page_num) {
        this.newsCond.page_num = e
        this.readItems()
      }
    },
    /*
    * 选择每页条数
    */
    onPageSizeChange (current, pageSize) {
      this.newsCond.page_num = current
      this.newsCond.page_size = pageSize
      this.readItems()
    },
    /*
    * 查询客户
    */
    readItems () {
      this.loading = true
      this.get({
        url: 'newsRead',
        data: this.newsCond
      }, (r) => {
        this.loading = false
        if (r.code) {
          this.newsTotal = r.data.total
          this.newsData = r.data.items
        } else {
          this.error(r.msg)
        }
      })
    }
  }
}
</script>
<style lang="less">
  @import url('../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .contact-news {
    .filter-input {
      margin-bottom: 0;
      .item-input {
        width: 100%;
      }
    }
    .card-date {
      margin-top: 20px;
    }
    .card-item {
      .card-title {
        line-height: 1.4em;
        font-weight: bold;
        margin: 10px 0;
        font-family: Georgia, 宋体;
      }
      .title-border {
        width: 100%;
        height: 1px;
        background: @graydark;
        &:after {
          content: '';
          display: block;
          width: 40px;
          height: 1px;
          background: @primary;
        }
      }
      &:hover {
        .card-title {
          color: @primary;
          cursor: pointer;
        }
        .title-border {
          background: @primary;
        }
      }
      .card-content {
        p {
          display: none;
        }
        p:first-child {
          display: block;
        }
      }
      .card-btn {
        font-size: 18px;
        padding: 0 0 20px;
        .primary:hover {
          color: @support;
          cursor: pointer;
        }
      }
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .contact-news {
    .card-date {
      margin-bottom: 20px;
    }
    .card-item {
      .card-title {
        height: 78px;
        line-height: 1.4em;
        font-weight: bold;
        margin-bottom: 10px;
        font-family: Georgia, 宋体;
      }
      .silver {
        height: 83px;
      }
      .title-border {
        width: 100%;
        height: 2px;
        background: @graydark;
        &:after {
          content: '';
          display: block;
          width: 40px;
          height: 2px;
          transition: all .2s;
          background: @primary;
        }
      }
      &:hover {
        .card-title {
          color: @primary;
          cursor: pointer;
        }
        .title-border:after {
          width: 100%;
        }
      }
      .card-btn {
        font-size: 16px;
        padding: 10px 0 26px;
        .primary:hover {
          color: @support;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/news.vue